module.exports = __webpack_public_path__ + "img/MZ-1920.7dee7599.jpg";